export default __webpack_public_path__ + "static/media/DSC_9077-thumb.a1df8245.jpg";